import { Action } from '@ngrx/store';
import { Identity } from './identity.model';

/* eslint-disable @typescript-eslint/no-shadow */
export enum IdentityActionTypes {
  IdentityLoaded = '[Identity] Loaded',
  IdentityAuthenticated = '[Identity] Authenticated',
}
/* eslint-enable @typescript-eslint/no-shadow */

export class IdentityLoaded implements Action {
  public readonly type = IdentityActionTypes.IdentityLoaded;
  constructor(public payload: { identity: Identity }) {}
}

export class IdentityAuthenticated implements Action {
  public readonly type = IdentityActionTypes.IdentityAuthenticated;
  constructor(public payload: { identity: Identity }) {}
}

export type IdentityActions = IdentityLoaded | IdentityAuthenticated;
